package com.flowyride.feature.planner.ui

import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.min

/**
 * Side panel instead of the top bar + bottom sheet: wide screens, and phones in landscape (too low for a sheet).
 * Below [LandscapeMinWidth], a portrait phone whose height shrinks (keyboard in an in-app browser) stays narrow.
 */
internal fun isWideLayout(width: Dp, height: Dp): Boolean =
    width >= WideLayoutMinWidth || (width >= LandscapeMinWidth && width > height)

/** Full width on large screens; narrower on a small phone in landscape, so the map keeps room. */
internal fun sidePanelWidth(width: Dp): Dp = min(SidePanelMaxWidth, width * 0.47f)

private val WideLayoutMinWidth = 720.dp
private val LandscapeMinWidth = 600.dp
private val SidePanelMaxWidth = 380.dp
